export default __webpack_public_path__ + "cdfc3c0d5dbea5059e3cba5cbdc0dd20.png";